module.exports = __webpack_public_path__ + "img/fahim.ab24e9fd.jpeg";